import { envTypeGet } from "../common";
import { API_TYPES } from "./api_constants";

export type UrlBases = {
  auth: string;
  matsend: string;
};

export type ApiType = "auth" | "matsend";

export const apiUrlBasesGet = (): UrlBases => {
  const envType = envTypeGet();
  let urlBases = {
    auth: "http://localhost:3002/api/v1",
    matsend: "http://localhost:3001/api/v1",
  };
  if (envType === "production") {
    urlBases = {
      auth: "https://matsend.emlearn.info/api/auth-matsend/v1",
      matsend: "https://matsend.emlearn.info/api/matsend/v1",
    };
  }

  return urlBases;
};

export const apiTypeUrlBaseGet = (apiType: string): string => {
  const urlBases: UrlBases = apiUrlBasesGet();
  const url = urlBases[apiType as ApiType];
  return url;
};

export const apiTypeUrlGet = (apiType: string, path: string): string => {
  const urlBase: string = apiTypeUrlBaseGet(apiType);
  const url = urlBase + "/" + path;
  return url;
};

export const apiAuthUrlGet = (path: string = ""): string => {
  const url: string = apiTypeUrlGet(API_TYPES.AUTH, path);
  return url;
};

export const apiMatsendUrlGet = (path: string = ""): string => {
  const url: string = apiTypeUrlGet(API_TYPES.MATSEND, path);
  return url;
};
